import { Box } from "@material-ui/core"
import { SendWhatsappMsgToCustomer } from "pages/Customers/components/SendWhatsappMsgToCustomer"
import React from "react"

const ClipboardImagePaste = () => {
  return (
    <div>
      <SendWhatsappMsgToCustomer
        customer={{
          photo: "http://localhost:4010/images/avatar/default.png",
          id: 451587,
          name: "ivã",
          nickName: null,
          identification: null,
          document: null,
          cellPhone: "5541999377823",
          FacebookId: null,
          InstagramId: null,
          GoogleId: null,
          firstAccess: true,
          SMSCode: null,
          gender: null,
          email: "",
          secondaryEmail: null,
          dateBirth: null,
          phone1: null,
          branch1: null,
          phone2: null,
          branch2: null,
          phone3: null,
          branch3: null,
          zipCode: null,
          address: null,
          number: null,
          complement: null,
          city: null,
          district: null,
          state: null,
          openId: null,
          acceptPurchaseEmail: null,
          acceptPurchaseReminder: null,
          acceptActiveCall: null,
          active: true,
          allowReceiveEmail: true,
          contact: null,
          companyDocument: null,
          createdAt: "2023-01-31T16:20:19.000Z",
          updatedAt: "2023-01-31T16:20:19.000Z",
          CompanyCustomerTypeId: null,
          CompanyId: 1,
        }}
      />
    </div>
  )
}

type TDebugProps = {
  history: History
}
export default function Debug({ history }: TDebugProps) {
  return (
    <Box>
      <ClipboardImagePaste />
    </Box>
  )
}
